import React, {Component} from 'react';
import './style/auth.css';
import SignInForm from './forms/sign_in_form';
import {signInUser} from "./actions";
import {connect} from "react-redux";

class SignIn extends Component {

    signIn(formProps) {
        this.props.signInUser(formProps);
    }

    render() {
        return (
            <SignInForm onSignIn={this.signIn.bind(this)} />
        )
    }
}

export default connect(null, {signInUser })(SignIn);



// WEBPACK FOOTER //
// ./src/containers/auth/sign_in.js